import PropTypes from 'prop-types';

const Reset = ({ color, size, ...props }) => (
    <svg viewBox="0 0 24 24" width={size} height={size} {...props}>
        <path
            d="m13 11.6 2.5 2.5a.95.95 0 0 1 .275.7.95.95 0 0 1-.275.7.95.95 0 0 1-.7.275.95.95 0 0 1-.7-.275l-2.8-2.8a1 1 0 0 1-.3-.725V8q0-.425.288-.713A.96.96 0 0 1 12 7q.425 0 .713.288.288.289.287.712zM12 21q-3.025 0-5.425-1.788T3.35 14.55q-.125-.45.088-.85a.95.95 0 0 1 .662-.5.83.83 0 0 1 .763.188q.338.289.462.712a6.57 6.57 0 0 0 2.513 3.55Q9.701 19 12 19q2.925 0 4.963-2.038T19 12q0-2.925-2.038-4.963T12 5a6.75 6.75 0 0 0-3.225.8A7.4 7.4 0 0 0 6.25 8H8q.425 0 .713.288T9 9a.97.97 0 0 1-.288.713A.96.96 0 0 1 8 10H4a.97.97 0 0 1-.713-.288A.96.96 0 0 1 3 9V5q0-.425.288-.713A.96.96 0 0 1 4 4q.425 0 .713.288.288.289.287.712v1.35a8.7 8.7 0 0 1 3.113-2.475A8.9 8.9 0 0 1 12 3q1.875 0 3.513.713a9.2 9.2 0 0 1 2.85 1.924 9.2 9.2 0 0 1 1.925 2.85A8.7 8.7 0 0 1 21 12q0 1.875-.713 3.513a9.2 9.2 0 0 1-1.924 2.85 9.2 9.2 0 0 1-2.85 1.925A8.7 8.7 0 0 1 12 21"
            fill={color}
        />
    </svg>
);

export default Reset;

Reset.propTypes = {
    color: PropTypes.string.isRequired,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};
